import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {PaginationStripe} from '@pb/kit-component-pagination';

import {userRoleAuditLogStateActions, userRoleAuditLogStateSelector} from './slices/user-role-audit-log-state.slice';

import type {Pagination} from 'src/openapi/admin/models/Pagination';

type Props = {
    totalCount: number,
};

export const UserRoleAuditLogPagination = ({totalCount}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(userRoleAuditLogStateSelector);

    const onChangePageSize = useCallback((_currentPage: number, pageSize: number) => {
        dispatch(userRoleAuditLogStateActions.setPageSize(pageSize));
        dispatch(userRoleAuditLogStateActions.setCurrentPage(1));
    }, [dispatch]);

    const onPaginationChange = useCallback((changedPagination: Pagination) => {
        dispatch(userRoleAuditLogStateActions.setCurrentPage(changedPagination.currentPage));
    }, [dispatch]);

    return (
        <PaginationStripe
            goToPage={true}
            pageSize={cacheKeys.pagination.pageSize}
            totalCount={totalCount}
            currentPage={cacheKeys.pagination.currentPage}
            onPaginationChange={onPaginationChange}
            onChangePaginationSize={onChangePageSize}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={[25, 50]}
        />
    );
};
